<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg387"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs391"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath401"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path399" /></clipPath></defs><g
     id="g393"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g395"><g
         id="g397"
         clip-path="url(#clipPath401)"><g
           id="g403"
           transform="translate(70,472)"><path
             d="M 0,0 C 0,-8.28 -3.36,-15.78 -8.79,-21.21 -14.22,-26.64 -21.72,-30 -30,-30 c -16.57,0 -30,13.43 -30,30 0,16.57 13.43,30 30,30 C -13.43,30 0,16.57 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path405" /></g><g
           id="g407"
           transform="translate(193,472)"><path
             d="m 0,0 c 0,-16.57 -13.43,-30 -30,-30 -16.57,0 -30,13.43 -30,30 0,16.57 13.43,30 30,30 C -13.43,30 0,16.57 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path409" /></g><g
           id="g411"
           transform="translate(316,472)"><path
             d="m 0,0 c 0,-16.57 -13.43,-30 -30,-30 -16.57,0 -30,13.43 -30,30 0,16.57 13.43,30 30,30 C -13.43,30 0,16.57 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path413" /></g><g
           id="g415"
           transform="translate(70,349)"><path
             d="m 0,0 c 0,-16.57 -13.43,-30 -30,-30 -16.57,0 -30,13.43 -30,30 0,16.57 13.43,30 30,30 C -13.43,30 0,16.57 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path417" /></g><g
           id="g419"
           transform="translate(141.79,370.21)"><path
             d="m 0,0 c 5.43,5.43 12.93,8.79 21.21,8.79 16.57,0 30,-13.43 30,-30 0,-16.57 -13.43,-30 -30,-30 -16.57,0 -30,13.43 -30,30 0,8.28 3.36,15.78 8.79,21.21 z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path421" /></g><g
           id="g423"
           transform="translate(70,226)"><path
             d="m 0,0 c 0,-16.57 -13.43,-30 -30,-30 -16.57,0 -30,13.43 -30,30 0,16.57 13.43,30 30,30 C -13.43,30 0,16.57 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path425" /></g><g
           id="g427"
           transform="translate(193,226)"><path
             d="m 0,0 c 0,-16.57 -13.43,-30 -30,-30 -16.57,0 -30,13.43 -30,30 0,16.57 13.43,30 30,30 C -13.43,30 0,16.57 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path429" /></g><g
           id="g431"
           transform="translate(322,190)"><path
             d="M 0,0 V 60 C 0,76.57 13.43,90 30,90 46.57,90 60,76.57 60,60 V 30"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path433" /></g><g
           id="g435"
           transform="translate(61.21,450.79)"><path
             d="M 0,0 80.58,-80.58"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path437" /></g><g
           id="g439"
           transform="translate(163,319)"><path
             d="M 0,0 V -63"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path441" /></g><g
           id="g443"
           transform="translate(193,226)"><path
             d="M 0,0 H 69"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path445" /></g><g
           id="g447"
           transform="translate(402)"><path
             d="m 0,0 c -5.522,0 -10,4.477 -10,10 0,5.523 4.478,10 10,10 C 5.522,20 10,15.523 10,10 10,4.477 5.522,0 0,0"
             style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path449" /></g><g
           id="g451"
           transform="translate(382,190)"><path
             d="M 0,0 V 30 C 0,46.57 13.43,60 30,60 46.57,60 60,46.57 60,30 V 0 c 0,16.57 13.43,30 30,30 16.57,0 30,-13.43 30,-30 v -100 c 0,-35.512 -23.144,-65.624 -55.17,-76.071"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path453" /></g><g
           id="g455"
           transform="translate(356.999,10)"><path
             d="m 0,0 h -48.189 c -12.15,0 -23.64,5.52 -31.23,15.01 l -69,86.25 c -10.36,12.94 -8.26,31.82 4.68,42.16 12.94,10.34 31.84,8.25 42.16,-4.68 l 6.58,-8.23 V 330 c 0,16.57 13.43,30 30,30 16.57,0 30,-13.43 30,-30 v -90"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path457" /></g></g></g></g></svg>
</template>
